module.exports = __webpack_public_path__ + "static/kaputtmacher-seal-animated-c8d9766e08a7b6f051732efbe314ceb7.gif";